Bta = {
  callbacks: {
    variantChanged: function(variant) {
        if (!variant?.price) return;
        const priceElement = document.querySelector("[data-price]")
        if (!priceElement) return;
        const newFormattedPrice = theme?.moneyFormat?.replace("{{amount}}", (variant.price).toFixed(2));
        if (!newFormattedPrice) return;
        priceElement.textContent = newFormattedPrice;
    }
  }
}

const buyNowDisclaimer = () => {
  const container = document.querySelector('.rw-exclusions-info'); // Replace with the actual selector

  if (container) {
  	const wrapperDiv = document.createElement('div'); // Create a div to wrap the elements
  	wrapperDiv.className = "rw-recap-date-group rw-custom-fields"; // rw-recap-date-group only there to match Date label styling
  	wrapperDiv.style.margin = "15px 0";
  	wrapperDiv.innerHTML = `<div class="buy-now-info">
  		Please note that there may be a delay with delivery if there are existing rentals in place for the item. You'll be notified of the expected delivery date within 24 hours of your 'Buy Now order being placed, and you'll be given the option of a refund if the delay in dispatch will be more than 2 weeks.
  		</div>`;
  	container.appendChild(wrapperDiv);   // Append the div to the container
  }
  
  const days = document.querySelectorAll('input[name="Days"]');
  
  // Function to toggle the visibility based on Days option selected
  function toggleBuyNowMsg() {
  	const selectedMethod = document.querySelector('input[name="Days"]:checked');
  	console.log('selectedMethod', selectedMethod.value);
  	const wrapperDiv = document.querySelector('.rw-custom-fields');
  
  	if (selectedMethod && selectedMethod.value === "Buy Now") { // Match merchant's naming
  		wrapperDiv.classList.add('rw-show'); // Show the element by adding the class
  	} else {
  		wrapperDiv.classList.remove('rw-show'); // Hide the element by removing the class
  	}
  }
  
  // Run once on page load if Days fields exist
  if (days) {
  	toggleBuyNowMsg();
  
  	// Listen for changes in the 'Days' radio buttons
  	days.forEach(method => {
  		method.addEventListener('change', toggleBuyNowMsg);
  	});
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log('DOMContentLoaded')
  buyNowDisclaimer()
})

